@if(currentSection === 'targetProductGroups'){
<div class="flex-1 px-300-rem py-250-rem">
  <div>
    <div class="flex flex-col space-y-050-rem">
      <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Target product groups</h1>
      <p class="text-container-fg-muted text-label-md-weight-regular">
        Select all product groups you want to include in this rollout plan.
      </p>
    </div>

    <div class="flex gap-x-025-rem py-100-em w-180">
      <i
        class="icon_marina_ui_InfoOutlined text-container-fg-muted text-headline-sm"
        aria-hidden="true"></i>
      <p class="text-container-fg-muted text-body-lg-weight-regular">
        No automatic compatibility checks between firmware package and targeted product groups. Make
        sure the groups you add are compatible with the firmware package.
      </p>
    </div>

    <div
      class="border border-container-border-default rounded-050 mt-6 bg-container-bg-default max-w-236.5">
      <div class="max-w-114 py-150-rem">
        @for (selection of selectionInputs(); let i = $index; track selection.id) {
        <div
          class="flex gap-2 px-4 items-center relative"
          [ngClass]="{ 'mt-100-rem': i > 0 }">
          <div class="flex-1 relative">
            <div class="my-050-rem w-full">
              <mat-form-field [ngClass]="{'error-border': isInputInvalid(selection)}">
                <mat-label>Target product group</mat-label>
                <mat-select
                  [(value)]="selection.selectedProductGroup"
                  [disabled]="isEditingRolloutPlan() && !(rolloutPlanStatus() === 'Draft' || rolloutPlanStatus() === 'Ready for review')"
                  [compareWith]="compareProductGroups"
                  (selectionChange)="onProductGroupChange(
                  $event.value.name,$event.value.id,selection.id)">
                  @for (groupProduct of groupProducts; track groupProduct.id) {
                  <mat-option 
                  [value]="groupProduct"
                  [disabled]="isProductGroupDisabled(groupProduct, selection.id)"
                  >{{groupProduct.name}}</mat-option>
                  } @empty {
                  <mat-option disabled> No product groups available. </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if(isInputInvalid(selection)){
              <div
                class="flex items-center text-label-sm-weight-regular gap-025-em text-feedback-fg-error mt-025-em">
                <i
                  class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
                <span> {{ error }}</span>
              </div>
              } @else {
              <p class="text-container-fg-muted text-label-sm-weight-regular w-sm pt-025-rem">
                {{ (rolloutPlanStatus() === 'Active' || rolloutPlanStatus() === 'Inactive') ? '' : 'Select the product group(s) you want to target.' }}
              </p>
              }
            </div>
          </div>
          @if(i > 0 && canModifyTargets()){ 
          <div class="absolute -right-200-rem">
            <button
              aria-label="Remove input"
              class="cursor-pointer"
              (click)="removeSelectionInput(i)"
              type="button">
              <i class="icon_marina_ui_DeleteOutlined text-headline-lg-weight-regular"></i>
            </button>
          </div>
          }
        </div>
        }

        <div class="mt-050-em">
          @if(canModifyTargets()){
          <button
            aria-label="Add input"
            type="button"
            (click)="addSelectionInput()"
            class="rounded-full cursor-pointer bg-action-bg-default p-075-rem w-fit flex mx-auto">
            <i
              class="icon_marina_ui_PlusOutlined text-action-fg-inverted-permanent text-headline-lg-weight-regular"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
